import React from 'react';


export function Paksitan(props) {
	return (
		<svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_301_506)">
				<path d="M394.276 85.343L411.823 104.255L435.231 93.4127L422.666 115.944L440.213 134.857L414.901 129.869L402.337 152.401L399.258 126.787L373.946 121.799L397.354 110.958L394.276 85.343Z" fill="#F3F3F3" />
				<path d="M0 0.00366211H513V341.996H0V0.00366211Z" fill="#F3F3F3" />
				<path d="M128.25 -0.00830078H513V341.995H128.25V-0.00830078Z" fill="#01411C" />
				<path d="M362.616 213.871C331.518 236.34 288.092 229.347 265.623 198.248C243.152 167.149 250.147 123.724 281.246 101.255C290.942 94.2494 301.836 90.1083 312.921 88.6675C291.596 85.4783 269.058 90.2836 250.201 103.908C211.926 131.564 203.317 185.01 230.972 223.286C258.627 261.56 312.074 270.169 350.35 242.512C369.207 228.888 380.845 208.999 384.512 187.751C379.664 197.82 372.313 206.864 362.616 213.871ZM361.284 87.7206L378.802 106.599L402.17 95.7763L389.626 118.267L407.144 137.148L381.875 132.17L369.332 154.664L366.259 129.093L340.99 124.115L364.358 113.291L361.284 87.7206Z" fill="#F3F3F3" />
			</g>
			<defs>
				<clipPath id="clip0_301_506">
					<rect width="513" height="342" fill="white" transform="translate(0 -0.00634766)" />
				</clipPath>
			</defs>
		</svg>


	);
}